import type { Testimonial } from '../testimonials'

/**
 * Ben Bryan's words, from the closing card of
 * digitopia.co/customers/litehouse-foods/ — the five-part capture sent on
 * 2026-08-28 with *"birebir tıpa tıp aynısını tasarla"*, and the request that
 * the page close on the testimonial template.
 *
 * **Not the quote at the top of that page.** The reference runs two statements
 * by the same person: the AIMI-framework one under the header, which is a
 * `section` on the story, and this longer one in the card at the foot. Keeping
 * them apart is the whole reason `Story.closingQuote` was not used here — the
 * card's own quote is this, and the story never repeats it.
 *
 * The mark is the 300×300 transparent `litehousecard.png` already in the tree,
 * not the 150×100 white-ground file offered with the request: this card draws
 * marks straight onto `bg-band`, where a crop with no alpha prints a white
 * rectangle. The portrait is new and came with the request; on 2026-08-28 it was replaced by
 * the 900×900 black-and-white file supplied for it, which is why the source is now
 * `portrait-ben-bryan.png` rather than the 400×400 `.webp` that arrived first.
 */
export const added: Testimonial = {
  company: 'Litehouse Foods',
  logo: { name: 'Litehouse Foods', src: '/logo/litehousecard.png' },
  portrait: {
    src: '/photo/portrait-ben-bryan.png',
    alt: 'Ben Bryan, smiling, in a grey jacket and open-collar shirt, black and white.',
  },
  quote: [
    'At Litehouse Foods, we partnered with Fisher Management Partners and Digitopia to assess '
    + 'and accelerate our AI journey. The AI Maturity Index gave us a clear baseline, aligned '
    + 'our leadership team, and helped translate our AI vision into a practical roadmap for '
    + 'execution. The AIMI deliverables have helped refine my AI message to our executive team '
    + 'and business leaders. We’re now moving forward with clarity, governance, and real '
    + 'momentum.',
  ],
  attribution: 'Ben Bryan, Manager, Applications',
  story: 'litehouse-foods',
}
